import Axios from "@/tool/axios";

export default class Oss {
  constructor(options) {
    options = options || {};
    for (let attr in options) {
      this[attr] = options[attr];
    }
  }
  // 获取oss上传key
  getUploadKey() {
    return Axios({
      url: '/aichat/api/upload/getUploadKey',
      method: 'get'
    }).then(
      res => {
        return Promise.resolve(res);
      },
      err => Promise.reject(err)
    );
  }
}



// WEBPACK FOOTER //
// ./src/zzcbpmDashboard/tool/oss.js